export default __webpack_public_path__ + "static/media/blockchain-image-9steg.b57a8fb3.jpg";